import { HTTPMethod, APIVersion, AuthenticatedRequest } from "../requests/request";
import { Contest } from "../models/contest";

export interface AnalyticsQueryParameter {
    start_date: Date
    end_date: Date
}

export class API {

    /**
     * @returns {Promise<Contest>} The Promise contains either a result or an APIError if rejected
     */
    public static get<T>(path: string, query: AnalyticsQueryParameter & any, signal?: AbortSignal, apiURL?: string): Promise<T> {
        const { setFinancialMode, ...rest } = query
        let apiRequest = new AuthenticatedRequest<Contest>('/bpm-analytics/' + path, HTTPMethod.GET, APIVersion.v1_0, rest);
        apiRequest.abortSignal = signal
        if (apiURL) {
            apiRequest.overrideAPIUrl = apiURL
        }
        return apiRequest.send().then((data) => {
            return data.data
        })
    }

    /**
    * @returns {Promise<Contest>} The Promise contains either a result or an APIError if rejected
    */
    public static getv2<T>(path: string, query: AnalyticsQueryParameter & any, signal?: AbortSignal, apiURL?: string): Promise<T> {
        const { setFinancialMode, ...rest } = query
        let apiRequest = new AuthenticatedRequest<Contest>('/bpm-analytics/' + path, HTTPMethod.GET, APIVersion.v2_0, rest);
        apiRequest.abortSignal = signal
        if (apiURL) {
            apiRequest.overrideAPIUrl = apiURL
        }
        return apiRequest.send().then((data) => {
            return data.data
        })
    }

    /**
     * @returns {Promise<Contest>} The Promise contains either a result or an APIError if rejected
     */
    public static post<T>(path: string, query: AnalyticsQueryParameter & any, apiURL?: string): Promise<T> {
        let apiRequest = new AuthenticatedRequest<Contest>('/bpm-analytics/' + path, HTTPMethod.POST, APIVersion.v1_0, undefined, query);
        if (apiURL) {
            apiRequest.overrideAPIUrl = apiURL
        }
        return apiRequest.send().then((data) => {
            return data.data
        })
    }

}


// WEBPACK FOOTER //
// ./src/api/src/endpoints/bpm-analytics.ts